export default "__VITE_ASSET__a5a934a0__"